import { useFormik } from 'formik';
import { useEffect } from 'react';
import { CasesGeneral } from '../../../../../../shared/types/modules/cases-general';

export const useCasesGeneralRegisterHistory = (casesGeneral?: CasesGeneral) => {
    const formik = useFormik({
        initialValues: {
            createdBy: '',
            updatedBy: '',
        },
        onSubmit: console.log,
    });

    useEffect(() => {
        const { createdBy, updatedBy } = casesGeneral || {};
        formik.setValues({
            createdBy: createdBy
                ? `(${createdBy.username}) ${createdBy.name} ${createdBy.surname}`
                : '',
            updatedBy: updatedBy
                ? `(${updatedBy.username}) ${updatedBy.name} ${updatedBy.surname}`
                : '',
        });
    }, [casesGeneral]);

    return {
        formik,
    };
};
